import { useState } from "react";

import calendarIcon from "../../assets/calendar-icon.png"

import "./style.css"
import { useContextValue } from "../../context/context";

export const PickMonth = () => {
	const [isOpen, setIsOpen] = useState(false);

	const currentYear = new Date().getFullYear();
	const currentMonth = new Date().getMonth();

	const options = [
		'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'
	];
	const { setSelectedDate } = useContextValue()
	const [selectedValue, setSelectedValue] = useState(options[currentMonth]);


	const toggleDropdown = () => {
		setIsOpen(!isOpen);
	};

	const handleSelect = (value) => {
		setSelectedValue(value);
		setIsOpen(false);

		const selectedMonthIndex = options.indexOf(value);
		const newDate = new Date(currentYear, selectedMonthIndex, 1);
		setSelectedDate({date: newDate, isSelected: true});
	};

	return (
		<div className="pick-month">
			<img src={calendarIcon} alt="" />
			<div className="selected-value" onClick={toggleDropdown}>
				<div className="text-group">
					<p style={{fontSize: "18", fontWeight: "300"}}>{currentYear}</p>
					<p>{selectedValue}</p>
				</div>
				<span className="arrow">&#9660;</span>
			</div>
			{isOpen && (
				<div className="dropdown">
					{options.map((option, index) => (
						<div key={index} className="dropdown-item" onClick={() => handleSelect(option)}>
							{option}
						</div>
					))}
				</div>
			)}
		</div>
	);
}
